// OK
import { removeCodesIframe } from "@utils/wordpressUtil";
import React from "react";
import { DOMAIN } from "src/constants";

import style from "./RichTextWPViewer.module.scss";

const RichTextWPViewer = ({ content, className = "" }) => {
  if (!content || content === "") return null;
  // Change link content of wp
  let customContent = content.replace(
    new RegExp('src="/wp-content', "g"),
    `src=${DOMAIN}/wp-content`
  );
  // Remove text /codes_iframe–>
  customContent = removeCodesIframe(customContent);
  customContent = customContent.replace("/codes_iframe&#8211;>", "");
  customContent = customContent.replaceAll(
    'https://d3gxgptuxgz1ri.cloudfront.net',
    'https://cdn.vnrebates.io'
  );
  return (
    <div
      className={`${style["vnrb-rich-text-wp-viewer"]} ${className}`}
      dangerouslySetInnerHTML={{
        __html: customContent,
      }}
    ></div>
  );
};

export default RichTextWPViewer;
